import CryptoJS from 'crypto-js'
import axios from 'axios'
import { urlValue } from './url' 

const secretKey = 'IANestingKey'

export const encrypter = (object, key) => {
  let hash = CryptoJS.AES.encrypt(JSON.stringify(object), key).toString()
  return hash
}

export const unfolder = (hashedValue, key) => {
  if (hashedValue == null) return {}
  try {
    let auxValue = CryptoJS.AES.decrypt(hashedValue, key)
    let value = JSON.parse(auxValue.toString(CryptoJS.enc.Utf8))
    return value
  } catch (e) {
    return {}
  }
}

export const generateAndRegisterToken = async (ccmsId) => {
  try {

    const payload = {
      id: null,
      ccms_name: ccmsId,
      origen: 'Nesting',
      browser: navigator.userAgent,
      ip: '',
      host: window?.location?.hostname || ''
    }

    const encryptedData = encrypter(payload, secretKey)

    const createTokenRes = await axios.post(`${urlValue}/api/v2/create-token`, {
      data: encryptedData
    })

    const token = createTokenRes.data?.token
    if (!token) throw new Error('No se recibió token del backend')

    await axios.post(`${urlValue}/studio/authorize`, {
      usuario: encryptedData
    }, {
      headers: {
        'access-token': token
      }
    })

    return token
  } catch (error) {
    console.error('Error en generateAndRegisterToken:', error)
    throw error
  }
}